import React from "react";
import AlphaherdSectionContentCard from "../../component/shared/card/alphaherd.sectionContentCard";
import AlphaherdSectionImgCard from "../../component/shared/card/alphaherd.sectionImgCard";
import { islandClubData } from "./data";

const AlphaherdIslandSection = () => {
  return (
    <section className="alpha_island_section">
      <div className="container">
        <div className="section_wrapper">
          <div className="row">
            {islandClubData.map((d) => (
              <>
                <div className="col-md-6 section_img">
                  <AlphaherdSectionImgCard animDir="zoom-in" img={d.image} />
                </div>
                <div className="col-md-6 section_content">
                  <AlphaherdSectionContentCard
                    subTitle={d.subTitle}
                    title={d.title}
                    description={d.description}
                    buttonText1={d.button}
                    isClaimButton={true}
                    isButton={true}
                  />
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AlphaherdIslandSection;
